import React from 'react';
import HeroTitleUnderline from './HeroTitleUnderline';
import { HeroTitle, HeroTitleHighlight, HeroTitleUnderlineWrap } from './styles';

type Props = {
  title: string;
};

const HeroTitleContent: React.FC<Props> = ({ title }) => {
  const words = title.trim().split(/\s+/);

  if (words.length < 2) {
    return <HeroTitle>{title}</HeroTitle>;
  }

  const [firstWord, secondWord, ...remainingWords] = words;

  return (
    <HeroTitle>
      {firstWord}{' '}
      <HeroTitleHighlight>
        {secondWord}
        <HeroTitleUnderlineWrap>
          <HeroTitleUnderline />
        </HeroTitleUnderlineWrap>
      </HeroTitleHighlight>
      {remainingWords.length > 0 ? ` ${remainingWords.join(' ')}` : ''}
    </HeroTitle>
  );
};

export default HeroTitleContent;
